import {ChangeDetectionStrategy, Component, Inject, signal} from "@angular/core";
import {GenerertAnalyseDebugModell, SpørreundersøkelseId, SpørreundersøkelseRessursClient} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatIcon} from "@angular/material/icon";
import {MatProgressBar} from "@angular/material/progress-bar";
import {MatToolbar} from "@angular/material/toolbar";
import {asynkArbeidPågårSignal, standardMinimumVarighetKonfig} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {SubmitButtonKomponent} from "web-ng2/delt/komponenter/skjema/submit-button/submit-button";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";

/**
 * Dialog som lar bruker redigere promptet brukt for å generere analyse av resultatet av en spørreundersøkelse,
 * og vise analysen generert med det redigerte promptet. Generert analyse blir ikke lagret.
 *
 * Bør fjernes på sikt
 */
@Component({
    selector: 'spoerreundersoekelse-generer-analyse-debug-dialog',
    templateUrl: 'spørreundersøkelse-generer-analyse-debug-dialog.html',
    styleUrl: 'spørreundersøkelse-generer-analyse-debug-dialog.scss',
    host: {'data-testid': 'spørreundersøkelse-generer-analyse-debug-dialog'},
    imports: [
        HtmlFormatertKomponent,
        MatButton,
        MatDialogActions,
        MatDialogContent,
        MatFormField,
        MatIcon,
        MatIconButton,
        MatInput,
        MatLabel,
        MatProgressBar,
        MatToolbar,
        ReactiveFormsModule,
        SubmitButtonKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpørreundersøkelseGenererAnalyseDebugDialogKomponent {

    static vis(dialog: MatDialog, undersøkelseId: SpørreundersøkelseId) {
        return dialog.open<SpørreundersøkelseGenererAnalyseDebugDialogKomponent, DialogParametre, void>(SpørreundersøkelseGenererAnalyseDebugDialogKomponent,
          {
              data: {undersøkelseId} as DialogParametre,
              disableClose: true,
              ariaLabelledBy: 'spørreundersøkelse-generer-analyse-debug-dialog-tittel',
              width: '90vw',
              maxWidth: 1200
          });
    }

    laster = asynkArbeidPågårSignal();
    genererer = asynkArbeidPågårSignal(standardMinimumVarighetKonfig());

    skjema = new FormGroup({
        prompt: new FormControl<string>('', {nonNullable: true})
    });

    /** Analyse generert med redigert prompt, null inntil analyse er generert */
    resultat = signal<GenerertAnalyseDebugModell | null>(null);

    private readonly undersøkelseId: SpørreundersøkelseId;

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private dialogRef: MatDialogRef<SpørreundersøkelseGenererAnalyseDebugDialogKomponent, void>,
                private spørreundersøkelseRessurs: SpørreundersøkelseRessursClient) {
        this.undersøkelseId = parametre.undersøkelseId;
        this.lastPrompt();
    }

    async genererAnalyse() {
        this.resultat.set(null);
        this.resultat.set(await this.genererer.utfør(() => this.spørreundersøkelseRessurs.genererAnalyseDebug(this.undersøkelseId, this.skjema.getRawValue()).somPromise()));
    }

    lukk() {
        this.dialogRef.close();
    }

    //private hjelpemetoder

    private async lastPrompt() {
        const {prompt} = await this.laster.utfør(() => this.spørreundersøkelseRessurs.analysepromptDebug(this.undersøkelseId).somPromise());
        this.skjema.setValue({prompt: prompt ?? ''});
    }
}

export type DialogParametre = { undersøkelseId: SpørreundersøkelseId; };
